export default "__VITE_ASSET__9a09add0__"